// Copyright (C) 2023 Cochise Ruhulessin
// 
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { CurrentUser } from '../services'
import { ExploreContainer, FooterControl, LoginContainer } from '../components'
import './Home.scss'


interface ContainerProps {
  nav: HTMLIonNavElement
  user: CurrentUser
}


const Home: React.FC<ContainerProps> = ({
  nav,
  user
}) => {
  if (!nav) { return null }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar no-border>
          <IonTitle size="large">Apparaatregistratiesysteem</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {(user.isAuthenticated()) ? (
            <ExploreContainer nav={nav} user={user} />)
            : (<LoginContainer/>
        )}
      </IonContent>
      <FooterControl disableBackButton={true} nav={nav} user={user}/>
    </IonPage>
  );
};

export  { Home }
